import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { MARKETING_CHANNEL_ID } from '../theme/theme.constants';
import { STATE_ID_WA } from '../constants';

const usePoliciesValidation = () => {
  const store = useSelector(({
    personalInformation,
  }) => ({
    personalInformation,
  }), shallowEqual);

  const { personalInformation: { discountData } } = store;

  const costcoCustomer = useMemo(() => Boolean(discountData
    && discountData.id && discountData.memberId), [discountData]);

  const hasAnyFigoPolicy = useMemo(() => {
    if (!store.personalInformation.userInfo) {
      return false;
    }

    const companies = store.personalInformation.userInfo.Companies;

    return Boolean(
      companies?.find((comp) => comp.Id === MARKETING_CHANNEL_ID.figo),
    );
  }, [store.personalInformation.userInfo]);

  const hasOnlyFigoPolicies = useMemo(() => {
    if (!store.personalInformation.userInfo) {
      return false;
    }

    const companies = store.personalInformation.userInfo.Companies;

    return Boolean(
      companies?.every((comp) => comp.Id === MARKETING_CHANNEL_ID.figo),
    );
  }, [store.personalInformation.userInfo]);

  const isWACustomer = useMemo(() => {
    if (!store.personalInformation.userInfo?.Address) {
      return false;
    }

    return store.personalInformation.userInfo.Address.StateId === STATE_ID_WA;
  }, [store.personalInformation.userInfo]);

  return {
    costcoCustomer,
    hasAnyFigoPolicy,
    hasOnlyFigoPolicies,
    isWACustomer,
  };
};

export { usePoliciesValidation };
